import { render, staticRenderFns } from "./ModalNuovoCanale.vue?vue&type=template&id=b0166c58"
import script from "./ModalNuovoCanale.vue?vue&type=script&lang=js"
export * from "./ModalNuovoCanale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports